export default __webpack_public_path__ + "files/6f1462a75cab16ee77c8cc130dd9376a.woff2";